export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/shopify.e34aac2.svg";